/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-09-10 16:12:40
 * @LastEditTime: 2021-04-23 15:56:39
 * @LastEditors: lkz
 */
export default [
  {
    path: '/log',
    name: '/log',
    meta: {
      title: '日志'
    },
    component: () => import(/* webpackChunkName: "xinyunpage-log" */ '../views/log/log.vue')
  },
  {
    path: '/log/logTaskManage',
    name: '/logTaskManage',
    meta: {
      title: '日志任务管理'
    },
    component: () => import(/* webpackChunkName: "xinyunpage-log" */ '../views/log/logTaskManage/logTaskManage.vue')
  },
  {
    path: '/log/logEdit',
    name: '/logEdit',
    meta: {
      title: '日志任务管理'
    },
    component: () => import(/* webpackChunkName: "xinyunpage-log" */ '../views/log/logTaskManage/logEdit.vue')
  },
  {
    path: '/log/logTypeManage',
    name: '/logTypeManage',
    meta: {
      title: '日志主体/类型管理'
    },
    component: () => import(/* webpackChunkName: "xinyunpage-log" */ '../views/log/logTypeManage/logTypeManage.vue')
  },
  {
    path: '/log/groupRobot',
    name: '/groupRobot',
    meta: {
      title: '群机器人'
    },
    component: () => import(/* webpackChunkName: "xinyunpage-log" */ '../views/log/groupRobot/groupRobotList.vue')
  }
]
